import { Table } from 'antd';

interface TableResultProps {
  onTableChangeHandler?: any
  columns: Array<Object>,
  dataSource: Array<Object>,
  totalResultCount?: number;
}

const TableResult = (props: TableResultProps) => {

  return (
    <Table
      columns={props.columns}
      dataSource= {props.dataSource}
      pagination={false}
      // onChange={(state) => {
      //   onTableChangeHandler({...state});
      // }}
    />
  );
}

export default TableResult;